module.exports = __webpack_public_path__ + "img/tqb_logo_horizontal.89b95496.svg";